// extracted by mini-css-extract-plugin
export var modalFooter = "_sn-0";